import _slicedToArray from "C:\\Users\\Administrator\\Desktop\\KaporgLatestC\\KAPorg-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import { useStyleRegister } from '@ant-design/cssinjs';
import { genIconStyle } from '../../style';
import useToken from '../useToken';
var useResetIconStyle = function useResetIconStyle(iconPrefixCls, csp) {
  var _useToken = useToken(),
    _useToken2 = _slicedToArray(_useToken, 2),
    theme = _useToken2[0],
    token = _useToken2[1];
  // Generate style for icons
  return useStyleRegister({
    theme: theme,
    token: token,
    hashId: '',
    path: ['ant-design-icons', iconPrefixCls],
    nonce: function nonce() {
      return csp === null || csp === void 0 ? void 0 : csp.nonce;
    },
    layer: {
      name: 'antd'
    }
  }, function () {
    return [genIconStyle(iconPrefixCls)];
  });
};
export default useResetIconStyle;